import { eventTabUrlPath } from './utils';
import { browserHistory } from 'react-router';

function isValidRoute(name) {
  return [
    'activity',
    'donate',
    'gifts',
    'guestlist',
    'photos',
    'polls',
    'settings',
    'rsvp',
    'what-to-bring'
  ].includes(name);
}

for(let key in browserHistory) {
  exports[key] = browserHistory[key].bind(browserHistory);
}
export function isCurrentRoute(name) {
  return document.location.pathname.indexOf(`/${name}`) !== -1;
}

export function toRoute(name, options = {}) {
  if (!isValidRoute(name)) {
    evite.assert(false, `Unknown route "${name}"`);
    return false;
  }
  if (isCurrentRoute(name)) {
    return false;
  }

  window.app.router.preventScroll = Boolean(options.preventScroll);
  const tabUrl = eventTabUrlPath(name);
  window.app.router.push(tabUrl);
  return true;
}

window.app = window.app || {};
if (!window.app.router) {
  window.app.router = Object.assign({}, exports, {
    browserHistory
  });
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/app-router.es6